import {observer, React} from '@api'
import { CustomAttributeDefinition } from '@api/graphql';
import {FilterItemDefinition, SimpleFilterItemDefinition} from '@design-board'
import {ConfiguredFilterGroups, FilterCheckbox} from './'
import * as css from './FilterGroupItem.css';

interface FilterGroupItemProps {
  name: string,
  checked: boolean,
  excluded?: boolean
  count?: React.ReactNode,
  group?: string
  value?: any
  item?: SimpleFilterItemDefinition
  imageUrl?: string
  type?: string
  displayName?: string
  customAttributeDefinition?: CustomAttributeDefinition
  showIcon?: boolean
  className?: string
}

export const FilterGroupItem = observer<FilterGroupItemProps>(function FilterGroupItem(props) {
  const {type, item, name} = props

  if ((type === "vlpProduct" || type === 'vlpVersions') && name === "Unassigned") {
    return null
  }

  return (
    <li className={css.root}
        data-type='FilterGroupItem'
        data-id={item?.id}
    >
      <FilterCheckbox {...props} />
    </li>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/internal/FilterGroupItem.tsx